import request from '../../axios';

const getHomepageLabNotifModal = async () => {
  const {data}: {data: ILabModal} = await request.get(`api/v2/store/lab-modal`);
  return data;
};

export default getHomepageLabNotifModal;
